module.exports = __webpack_public_path__ + "img/install.0454ab89.png";